export interface Channel {
  id: string;
  name: string;
  en: string;
  desc: string;
  count: string;
  color: string;
  icon: string;
  image: string;
}

export const channels: Channel[] = [
  {
    id: 'ent',
    name: '娱乐星闻',
    en: 'Entertainment',
    desc: '明星动态与圈内话题，吃瓜风向最快的阵地，最新鲜的料都在这里最先冒头。',
    count: '今日速报 32+',
    color: 'bg-accent-500',
    icon: 'ri-mic-line',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20entertainment%20showbiz%20backstage%20with%20spotlights%20stage%20lights%20and%20curtains%2C%20orange%20coral%20and%20peach%20tone%20palette%20on%20soft%20cream%20background%2C%20playful%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20and%20airy%20composition%20with%20rounded%20shapes&width=800&height=600&seq=channel-ent&orientation=landscape',
  },
  {
    id: 'film',
    name: '影视档期',
    en: 'Film & Drama',
    desc: '新片定档、剧集收官与幕后花絮，档期日历和首播消息第一时间同步给你。',
    count: '今日速报 21+',
    color: 'bg-primary-500',
    icon: 'ri-clapperboard-line',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20cinema%20movie%20reel%20and%20popcorn%20bucket%20in%20a%20theater%2C%20tangerine%20coral%20and%20amber%20tone%20palette%20on%20soft%20cream%20background%2C%20playful%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20and%20airy%20composition%20with%20rounded%20shapes&width=800&height=600&seq=channel-film&orientation=landscape',
  },
  {
    id: 'variety',
    name: '综艺前线',
    en: 'Variety Shows',
    desc: '热门综艺录制路透与预告放送，谁来了、去哪录、看点在哪，一目了然。',
    count: '今日速报 18+',
    color: 'bg-secondary-500',
    icon: 'ri-camera-lens-line',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20television%20variety%20show%20set%20with%20big%20smiling%20sun%20and%20confetti%20and%20gameshow%20buzzers%2C%20coral%20orange%20and%20golden%20tone%20palette%20on%20soft%20cream%20background%2C%20playful%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20composition%20with%20rounded%20shapes&width=800&height=600&seq=channel-variety&orientation=landscape',
  },
  {
    id: 'society',
    name: '社会现场',
    en: 'Society',
    desc: '全网热议的社会话题与城市动态，重大节点与事件脉络持续追踪不遗漏。',
    count: '今日速报 26+',
    color: 'bg-accent-500',
    icon: 'ri-earth-line',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20bustling%20city%20skyline%20with%20rising%20trend%20arrows%20and%20people%20gathering%20under%20street%20lights%2C%20terracotta%20orange%20and%20peach%20tone%20palette%20on%20soft%20cream%20background%2C%20playful%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20composition%20with%20rounded%20shapes&width=800&height=600&seq=channel-society&orientation=landscape',
  },
  {
    id: 'news',
    name: '资讯速递',
    en: 'Quick News',
    desc: '科技、文化、消费与时事热点的即时资讯，五分钟扫完一整天的重要消息。',
    count: '今日速报 24+',
    color: 'bg-primary-500',
    icon: 'ri-flashlight-line',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20rapid%20news%20dispatch%20scene%20with%20envelope%20rocket%20and%20speed%20lines%2C%20sunrise%20orange%20and%20coral%20tone%20palette%20on%20soft%20cream%20background%2C%20playful%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20composition%20with%20rounded%20shapes&width=800&height=600&seq=channel-news&orientation=landscape',
  },
  {
    id: 'meme',
    name: '网络热梗',
    en: 'Memes & Trends',
    desc: '流行热梗与二次传播盘点，看懂大家为什么都在刷，跟上网络节奏。',
    count: '今日速报 14+',
    color: 'bg-secondary-500',
    icon: 'ri-emotion-happy-line',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20playful%20speech%20bubbles%20emoji%20faces%20and%20viral%20sparkles%2C%20coral%20golden%20and%20peach%20tone%20palette%20on%20soft%20cream%20background%2C%20playful%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20composition%20with%20rounded%20shapes&width=800&height=600&seq=channel-meme&orientation=landscape',
  },
];